"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./FeatureLabel.css");
var icons = require("./../../../../../styles/att-icons.css");
var Label_1 = require("../../../../atoms/Label");
var LabelProps_1 = require("../../../../atoms/Label/LabelProps");
var utils_1 = require("../../../../../utils/utils");
var FeatureLabel = /** @class */ (function (_super) {
    __extends(FeatureLabel, _super);
    function FeatureLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureLabel.prototype.render = function () {
        var labelData = __assign({ text: this.props.data.text }, (typeof this.props.data.isDecodingRequired !== 'undefined')
            ? { isDecodingRequired: this.props.data.isDecodingRequired } : null);
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.featureLabel },
            React.createElement("div", { className: styles.featureIcon },
                this.props.options && this.props.options.iconFont && this.props.options.iconName &&
                    React.createElement("i", { className: [styles.icon, this.props.options.iconFont, this.props.options.iconName].join(' ') }),
                (!this.props.options || !this.props.options.iconFont || !this.props.options.iconName) &&
                    React.createElement("i", { className: [icons.attIcon, icons.attIconCheck, styles.checkIcon].join(' '), "aria-label": "bullet point", role: "img" })),
            React.createElement("div", { className: styles.featureDetail },
                React.createElement("div", { className: styles.text },
                    React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label', 'Feature'), data: labelData, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } })),
                this.renderDescription())));
    };
    FeatureLabel.prototype.renderDescription = function () {
        if (this.props.data.description) {
            return (React.createElement("div", { className: styles.detail },
                React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label', 'Description'), data: __assign({ text: this.props.data.description }, (typeof this.props.data.isDecodingRequired !== 'undefined')
                        ? { isDecodingRequired: this.props.data.isDecodingRequired } : null), options: { size: LabelProps_1.LabelSizes.LEGALCOPY } })));
        }
    };
    return FeatureLabel;
}(React.Component));
exports.default = FeatureLabel;
//# sourceMappingURL=FeatureLabel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/FeatureList/components/FeatureLabel/FeatureLabel.js
// module id = 545
// module chunks = 8